<template>
    <svg v-if="!bold" width="10" height="10" viewBox="0 0 10 10" :fill="fill" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.86401 2.19708C9.1569 1.90418 9.1569 1.42931 8.86401 1.13642C8.57112 0.843525 8.09624 0.843525 7.80335 1.13642L8.86401 2.19708ZM1.13666 7.8031C0.843769 8.096 0.843769 8.57087 1.13666 8.86376C1.42956 9.15666 1.90443 9.15666 2.19732 8.86376L1.13666 7.8031ZM2.19734 1.13642C1.90445 0.843525 1.42958 0.843525 1.13668 1.13642C0.84379 1.42931 0.84379 1.90418 1.13668 2.19708L2.19734 1.13642ZM7.80337 8.86376C8.09626 9.15666 8.57114 9.15666 8.86403 8.86376C9.15692 8.57087 9.15692 8.096 8.86403 7.8031L7.80337 8.86376ZM7.80335 1.13642L1.13666 7.8031L2.19732 8.86376L8.86401 2.19708L7.80335 1.13642ZM1.13668 2.19708L7.80337 8.86376L8.86403 7.8031L2.19734 1.13642L1.13668 2.19708Z"
        />
    </svg>
    <svg v-else width="9" height="9" viewBox="0 0 8 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.99999 1.5L0.999969 7.50002M0.999989 1.5L7.00001 7.50002"
            :stroke="fill"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script>
export default {
    props: {
        bold: {
            type: Boolean,
            default: false
        },
        fill: {
            type: String,
            default: () => "#DD4141"
        }
    },
    name: "CloseIcon"
}
</script>
